<p>modify-object-group works!</p>
